import React from 'react';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import type { ReactNode } from 'react';
import styles from './DataTable.module.scss';
import { Panel } from '../Panel/Panel';
import { Loading } from '../Loading/Loading';

interface DataTableProps {
    children: ReactNode;
    colgroup?: ReactNode;
    toolbar?: ReactNode;
    footer?: ReactNode;
    empty?: ReactNode;
    loading?: boolean;
    isLoading?: boolean;
    loadingText?: string;
    static?: boolean;
    bordered?: boolean;
    className?: string;
    scrollKey?: string | number;
}

export const DataTable = forwardRef<HTMLDivElement, DataTableProps>(function DataTable(
    {
        children,
        colgroup,
        toolbar,
        footer,
        empty,
        loading,
        isLoading = false,
        loadingText = 'Загружаем…',
        bordered = true,
        className,
        scrollKey,
    },
    ref,
) {
    const scrollRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => scrollRef.current as HTMLDivElement);

    useEffect(() => {
        if (scrollKey === undefined) return;

        scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }, [scrollKey]);

    return (
        <Panel bordered={bordered}>
            {toolbar}
            <div className={styles.scroll} ref={scrollRef} data-loading={loading || undefined}>
                <table className={className}>
                    {colgroup}
                    {children}
                </table>

                {isLoading ? <Loading text={loadingText} /> : empty}
            </div>
            {footer}
        </Panel>
    );
});

export { styles as tableStyles };